export { PipesModule } from './pipes.module';
